'use strict';

var _commonjsHelpers = require('./_commonjsHelpers.js');
var index = require('../node_modules/react-swipeable/es/index.js');

var require$$1 = /*@__PURE__*/_commonjsHelpers.getAugmentedNamespace(index);

module.exports = require$$1;
